var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-item",class:_vm.isStyledItem ? 'text-center' : ''},[(_vm.icon)?_c('div',{staticClass:"text-item__icon mx-auto mb-5",class:[
    _vm.isIconReplaced ? 'logo_as_icon' : '',
    _vm.colorVariant ? 'shaded-fill-' + _vm.colorVariant : ''
  ]},[(this.isIconReplaced)?_c('logo',{staticClass:"mt-2",attrs:{"whitelabel-config":_vm.whitelabelConfig}}):_c('simple-svg',{attrs:{"src":`${_vm.ASSETS_URL}${_vm.icon}`}})],1):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.$t(_vm.itemText, {
        ASSETS_URL: _vm.ASSETS_URL,
        ..._vm.additionalData,
        parent: _vm.parent,
        currency: _vm.locale.currency,
        token: _vm.interactionInstanceToken,
        locale: _vm.locale.id,
        externalUserToken: _vm.externalUserReference,
        evaluatorDashboardLink: _vm.evaluatorDashboardLink,
        clientInteractionResultsLink: _vm.clientInteractionResultsLink,
      })
    )}})])
}
var staticRenderFns = []

export { render, staticRenderFns }